import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import Logger from '../services/Logger';
import FHIRService from '../services/FHIRService';
import fhirDataFormatter from '../utils/fhirDataFormatter';
var logger = new Logger('core.ProfileManager');

var ProfileManager = /*#__PURE__*/function () {
  function ProfileManager() {
    _classCallCheck(this, ProfileManager);

    this._userId = null; // user login id

    this._activePatientId = null; // user fhir id

    this._profiles = [];
  }

  _createClass(ProfileManager, [{
    key: "getSelfProfile",
    value: function getSelfProfile() {
      return this._profiles.find(function (p) {
        return p.relationship === 'self';
      });
    }
  }, {
    key: "addProfile",
    value: function () {
      var _addProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(profile) {
        var relationship,
            patientFullName,
            patientDob,
            patientToAdd,
            patientFhirService,
            _yield$patientFhirSer,
            patient,
            relatedPersonToCreate,
            relatedPersonFhirService,
            _yield$relatedPersonF,
            relatedPerson,
            _this$getSelfProfile,
            parentPatientId,
            _yield$patientFhirSer2,
            parentPatient,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                relationship = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
                patientFullName = profile.patientFullName, patientDob = profile.patientDob;
                _context.prev = 2;
                patientToAdd = {
                  resourceType: 'Patient',
                  active: true
                };

                if (patientFullName) {
                  patientToAdd.name = [{
                    given: [patientFullName]
                  }];
                }

                if (patientDob) {
                  patientToAdd.birthDate = moment(patientDob).format('YYYY-MM-DD');
                } // Create Patient for new profile


                patientFhirService = new FHIRService('Patient');
                _context.next = 9;
                return patientFhirService.create(patientToAdd);

              case 9:
                _yield$patientFhirSer = _context.sent;
                patient = _yield$patientFhirSer.data;
                // Create RelatedPerson for new profile
                relatedPersonToCreate = {
                  resourceType: 'RelatedPerson',
                  active: true,
                  patient: {
                    reference: "Patient/".concat(patient.id)
                  }
                };

                if (relationship) {
                  relatedPersonToCreate.relationship = relationship;
                }

                relatedPersonFhirService = new FHIRService('RelatedPerson');
                _context.next = 16;
                return relatedPersonFhirService.create(relatedPersonToCreate);

              case 16:
                _yield$relatedPersonF = _context.sent;
                relatedPerson = _yield$relatedPersonF.data;
                // Link new profile to parent patient
                _this$getSelfProfile = this.getSelfProfile(), parentPatientId = _this$getSelfProfile.patientId;
                _context.next = 21;
                return patientFhirService.read(parentPatientId);

              case 21:
                _yield$patientFhirSer2 = _context.sent;
                parentPatient = _yield$patientFhirSer2.data;
                parentPatient.link = parentPatient.link || [];
                parentPatient.link.push({
                  other: {
                    reference: "RelatedPerson/".concat(relatedPerson.id)
                  },
                  type: 'seealso'
                });
                _context.next = 27;
                return patientFhirService.update(parentPatientId, parentPatient);

              case 27:
                // Update profiles
                this._profiles.push({
                  patientId: patient.id,
                  patientFullName: fhirDataFormatter.formatPatientName(patient.name),
                  patientDob: patient.birthDate,
                  relationship: relationship
                });

                _context.next = 33;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](2);
                logger.error('Failed to create new profile', _context.t0);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 30]]);
      }));

      function addProfile(_x) {
        return _addProfile.apply(this, arguments);
      }

      return addProfile;
    }()
  }, {
    key: "updateProfile",
    value: function () {
      var _updateProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(profile) {
        var patientIdToUpdate, patientFhirService, _yield$patientFhirSer3, patientToUpdate, patientFullName, patientDob, profileIndexToUpdate;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                patientIdToUpdate = profile.patientId; // Get the latest version of patient

                patientFhirService = new FHIRService('Patient');
                _context2.next = 5;
                return patientFhirService.read(patientIdToUpdate);

              case 5:
                _yield$patientFhirSer3 = _context2.sent;
                patientToUpdate = _yield$patientFhirSer3.data;
                patientFullName = profile.patientFullName, patientDob = profile.patientDob;

                if (patientFullName) {
                  patientToUpdate.name = [{
                    given: [patientFullName]
                  }];
                }

                if (patientDob) {
                  patientToUpdate.birthDate = moment(patientDob).format('YYYY-MM-DD');
                } // TODO: Update relationship in related person


                _context2.next = 12;
                return patientFhirService.update(patientIdToUpdate, patientToUpdate);

              case 12:
                // Update profiles
                profileIndexToUpdate = this._profiles.findIndex(function (p) {
                  return p.patientId === patientIdToUpdate;
                });

                if (!(profileIndexToUpdate < 0 || profileIndexToUpdate >= this._profiles.length)) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return");

              case 15:
                this._profiles[profileIndexToUpdate] = profile;
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](0);
                logger.error('Failed to remove profile', _context2.t0);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 18]]);
      }));

      function updateProfile(_x2) {
        return _updateProfile.apply(this, arguments);
      }

      return updateProfile;
    }()
  }, {
    key: "removeProfile",
    value: function () {
      var _removeProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(patientIdToRemove) {
        var _this$getSelfProfile2, parentPatientId, relatedPersonFhirService, _yield$relatedPersonF2, relatedPersonBundle, relatedPerson, patientFhirService, _yield$patientFhirSer4, parentPatient, linkIndexToRemove, profileIndexToRemove;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _this$getSelfProfile2 = this.getSelfProfile(), parentPatientId = _this$getSelfProfile2.patientId; // Skip if trying to remove parent patient

                if (!(parentPatientId === patientIdToRemove)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                // Get related person
                relatedPersonFhirService = new FHIRService('RelatedPerson');
                _context3.next = 7;
                return relatedPersonFhirService.search([{
                  patient: "Patient/".concat(patientIdToRemove)
                }]);

              case 7:
                _yield$relatedPersonF2 = _context3.sent;
                relatedPersonBundle = _yield$relatedPersonF2.data;

                if (!(!relatedPersonBundle || !relatedPersonBundle.entry || !relatedPersonBundle.entry.length)) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return");

              case 11:
                relatedPerson = relatedPersonBundle.entry[0].resource; // Get the latest version of parent patient

                patientFhirService = new FHIRService('Patient');
                _context3.next = 15;
                return patientFhirService.read(parentPatientId);

              case 15:
                _yield$patientFhirSer4 = _context3.sent;
                parentPatient = _yield$patientFhirSer4.data;

                if (!(!parentPatient.link || !parentPatient.link.length)) {
                  _context3.next = 19;
                  break;
                }

                return _context3.abrupt("return");

              case 19:
                linkIndexToRemove = parentPatient.link && parentPatient.link.findIndex(function (l) {
                  return l.other && l.other.reference === "RelatedPerson/".concat(relatedPerson.id);
                });

                if (!(linkIndexToRemove < 0 || linkIndexToRemove >= parentPatient.link.length)) {
                  _context3.next = 22;
                  break;
                }

                return _context3.abrupt("return");

              case 22:
                parentPatient.link.splice(linkIndexToRemove, 1);
                _context3.next = 25;
                return patientFhirService.update(parentPatientId, parentPatient);

              case 25:
                // Update profiles
                this._activePatientId = parentPatientId;
                profileIndexToRemove = this._profiles.findIndex(function (p) {
                  return p.patientId === patientIdToRemove;
                });

                if (!(profileIndexToRemove < 0 || profileIndexToRemove >= this._profiles.length)) {
                  _context3.next = 29;
                  break;
                }

                return _context3.abrupt("return");

              case 29:
                this._profiles.splice(profileIndexToRemove, 1);

                _context3.next = 35;
                break;

              case 32:
                _context3.prev = 32;
                _context3.t0 = _context3["catch"](0);
                logger.error('Failed to remove profile', _context3.t0);

              case 35:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 32]]);
      }));

      function removeProfile(_x3) {
        return _removeProfile.apply(this, arguments);
      }

      return removeProfile;
    }()
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "userId",
    get: function get() {
      return this._userId;
    },
    set: function set(value) {
      this._userId = value;
    }
  }, {
    key: "activePatientId",
    get: function get() {
      return this._activePatientId;
    },
    set: function set(value) {
      this._activePatientId = value;
    }
  }, {
    key: "profiles",
    get: function get() {
      return this._profiles;
    },
    set: function set(value) {
      this._profiles = value;
    }
  }, {
    key: "activeProfile",
    get: function get() {
      var _this = this;

      return this._profiles.find(function (p) {
        return p.patientId === _this._activePatientId;
      });
    }
  }]);

  return ProfileManager;
}(); // Singleton Export


var profileManager = new ProfileManager();
var _default = profileManager;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/ProfileManager.js");
  reactHotLoader.register(ProfileManager, "ProfileManager", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/ProfileManager.js");
  reactHotLoader.register(profileManager, "profileManager", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/ProfileManager.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/ProfileManager.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();